import { render, staticRenderFns } from "./BgUploadModal.vue?vue&type=template&id=16190f9a"
import script from "./BgUploadModal.vue?vue&type=script&lang=js"
export * from "./BgUploadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports